import _ from 'lodash'
import config from '../config/directline'

function isQuickReply(message) {
  return (message.attachments &&
    message.attachments[0].contentType === 'quickReply')
}

function isTyping(message) {
  return (message.type === 'typing')
}

function isBotMessage(message) {
  return (message.type !== 'typing' && !message.recipient)
}

function isTextMessage(message) {
  return (!message.attachments && message.type === 'message')
}

function isInfoMessage(message) {
  return (message.attachmentLayout === 'infoMessage')
}

function isUserMessage(message) {
  return (message.recipient || _.get(message, 'from.name') !== config.from.name)
}

function isPopup(message) {
  return (message.entities && message.entities[0].popup && message.entities[0].popup.title)
}

function isCarousel(message) {
  return (message.attachmentLayout === 'carousel')
}

function isListButton(message) {
  return (message.attachments &&
    message.attachments[0].contentType === 'listButton')
}

function isImage(message) {
  return (message.attachments &&
    message.attachments[0].contentType === 'image/jpeg')
}

function isVideo(message) {
  return (message.attachments &&
    message.attachments[0].contentType === 'application/vnd.microsoft.card.video')
}

export {
  isQuickReply,
  isTyping,
  isBotMessage,
  isTextMessage,
  isCarousel,
  isPopup,
  isListButton,
  isImage,
  isVideo,
  isUserMessage,
  isInfoMessage,
}



// WEBPACK FOOTER //
// ./src/redux/utils.js